import React from "react";
import styled from "styled-components";
import { TableHeaderColumn } from "components";

export const TableHeader = ({ sortCol, sortType, onSort = () => {} }) => {
  return (
    <Container>
      {/* <TableHeaderColumn></TableHeaderColumn> */}
      <TableHeaderColumn label="Name"></TableHeaderColumn>
      <TableHeaderColumn label="Version"></TableHeaderColumn>
      <TableHeaderColumn label="Status"></TableHeaderColumn>
      <TableHeaderColumn label="Notes"></TableHeaderColumn>
      <TableHeaderColumn label="Match Filter"></TableHeaderColumn>
      <TableHeaderColumn label="Created Date"></TableHeaderColumn>
      <TableHeaderColumn
        name="completed_time"
        label="Last Run Date"
        sortCol={sortCol}
        sortType={sortType}
        onSort={onSort}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0 0px 0 32px;
  color: white;
  font-size: ${(props) => props.theme.palette.m};
  margin: 28px 12px 15px 12px;

  & > div:nth-child(1) {
    width: 300px;
  }
  & > div:nth-child(2) {
    width: 120px;
  }
  & > div:nth-child(3) {
    width: 120px;
  }
  & > div:nth-child(4) {
    width: 300px;
  }
  & > div:nth-child(5) {
    width: 120px;
  }
  & > div:nth-child(6) {
    width: 120px;
  }
  & > div:nth-child(7) {
    flex: 1;
  }
`;
